import React from 'react'

const StrikethroughPrice = ({strikethroughRial, amountRial}) => {
  return (
    <div className="package-price-wrapper single-package-price">
    {strikethroughRial && (
      <div className="package-strikethrough-wrapper">
        <span>
          {(
            strikethroughRial / 10
          ).toLocaleString()}{" "}
          تومان
        </span>
        <span className="package-strikethrough"></span>
      </div>
    )}

    <span className="amount">
      {(amountRial / 10).toLocaleString()} تومان
    </span>
  </div>
  )
}

export default StrikethroughPrice
